module.exports = __webpack_public_path__ + "img/countries.8d32e060.jpg";